import { VText } from '@vake/ui-kit';
import { FC } from 'react';

const Description: FC = () => (
    <div className="flex flex-col max-w-[575px] mx-auto gap-4">
        <VText variant="H1">Find focus with our unique maritime insight</VText>
        <VText>
            Illegal fishing, assets protection, and environmental crimes are maritime challenges faced by governments
            and businesses around the world. The vastness of the sea and the limited traceability of ships create large
            information gaps, adding to the complexity of these challenges. Satellite images could fill in some of the
            blanks, but the images are just as vast as the oceans themselves. To get actionable insights from this data
            is laborious work – this is where we come in.
            <br /> <br />
            We use machine learning to automatically detect ships in satellite images. The result of our sole maritime
            focus is in a specialized algorithm capable of generating training data. This makes us uniquely flexible in
            terms of dat a source, scalability, and the degree of human verification. Creating one-of-a kind maritime
            insight suited to your needs.
        </VText>
    </div>
);

export default Description;
